module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("22sLR"))).then(() => module.bundle.root('2KbAe'));